import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Typography,
  Card, CardHeader,
  Avatar,
  Button, FormControl, Select, InputLabel, MenuItem
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { LoadingButton } from '@mui/lab';
import Page from '../../components/Page';
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
import qs from 'qs'
import request from '../../components/request'
import { Routes, Route, useParams, useNavigate } from 'react-router-dom';

var defaultSecond = 60;
var timer = null;
var jishi = null;
export default function ChangeEmail() {
  var navigate = useNavigate();
  let { oldEmail } = useParams();

  let [js, setJs] = useState(null);
  let [jishi_ing, setJishi_ing] = useState(false);

  useEffect(() => {
    if (global.isDevelopment) defaultSecond = 10;
  }, [])

  const LoginSchema = Yup.object().shape({
    //Mobile: Yup.string().required('手机号 必填'),
    CheckCode: Yup.string().required('验证码 必填')
  });

  const formik = useFormik({
    initialValues: {
      Email: oldEmail,
      CodeCiphertext: '',
      CheckCode: '',
    },
    validationSchema: LoginSchema,
    onSubmit: (values, actions) => {
      actions.setSubmitting(true);
      //验证
      console.log('values', JSON.stringify(values));
      submit(values).then(result => {
        //if (!result) {
        actions.setSubmitting(false);
        //}
      })
    }
  });

  const submit = async (values) => {
    if (values.CodeCiphertext.length < 1) {
      global.addMessage('请先获取验证码');
      return false;
    }

    const data = values;
    const result = await request.PostFormData('Web/Public/CheckOldEmailCode', data);
    if (result.Code === 1) {
      //global.addMessage(result.Message);
      var oldCheckMsg = result.Result.oldCheckMsg;

      navigate(`/dashboard/profile/safe/bindemail/${oldCheckMsg}`, { replace: true });

      return true;
    }
    else
      global.addMessage(result.Message);

    return false;
  }

  const jianMiao = () => {
    jishi--;
    setJs(jishi);
    if (jishi <= 0) {
      clearInterval(timer);
      setJishi_ing(false);
    }
  }
  const sendCode = async () => {
    if (!jishi_ing) {
      //调用接口发送验证码
      const result = await request.PostFormData('Web/Public/SendMsgForOldEmail', {});
      if (result.Code === 1) {

        //CodeCiphertext = result.Result;
        formik.setFieldValue('CodeCiphertext', result.Result);

        jishi = defaultSecond;
        setJs(jishi);
        setJishi_ing(true);

        timer = setInterval(() => {
          jianMiao();
        }, 1000);
      }
      else
        global.addMessage(result.Message);
    }
  }

  const { errors, touched, values, isSubmitting, handleChange, handleSubmit, getFieldProps } = formik;

  return (
    <Card>
      <CardHeader title="验证邮箱" subheader="" />
      <Box p={3}>
        <FormikProvider value={formik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack spacing={3} alignItems={'flex-start'}>
              <TextField
                disabled
                autoComplete="Email"
                type="text"
                label="邮箱号"
                {...getFieldProps('Email')}
                error={Boolean(touched.Email && errors.Email)}
                helperText={touched.Email && errors.Email}
                sx={{ width: 300 }}
              />

              <Stack direction={'row'} spacing={1.5} alignItems={'center'}>
                <TextField
                  autoComplete="CheckCode"
                  type="text"
                  label="验证码"
                  {...getFieldProps('CheckCode')}
                  error={Boolean(touched.CheckCode && errors.CheckCode)}
                  helperText={touched.CheckCode && errors.CheckCode}
                  sx={{ width: 200 }}
                />
                <Button disabled={jishi_ing} onClick={() => { sendCode() }}>{jishi_ing ? `${js} 秒` : '发送验证码'}</Button>
              </Stack>


              <Stack sx={{ my: 4 }}></Stack>

              <LoadingButton

                size="large"
                type="submit"
                variant="contained"
                loading={isSubmitting}
              >
                验证
              </LoadingButton>
            </Stack>
          </Form>
        </FormikProvider>
      </Box>
    </Card >
  );
}
